import React from 'react';
import { Col, Row } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { SMLContainer } from '../../smartLinks/smlContainer/SMLContainer';
import { SMLDatePicker } from '../components/SMLDatePicker/SMLDatePicker';
import { CombinedPlaylistReachPanel } from '../components/CombinedPlaylistReachPanel/CombinedPlaylistReachPanel';
import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';
import { useSMLDatePickerDateParam } from '../hooks/useSMLDatePickerDateParam';
import { useCanFilterGeographically } from '../hooks/useCanFilterGeographically';
import { useTopCountries } from './hooks/useTopCountries';
import { TopMarketsCard } from './TopMarketsCard';
import { ChartsPageHead } from '../charts/ChartsPageHead';
import { PageTabsInBody } from '../components/SMLPageHead/PageTabsInBody';
import { ChartsTabRow } from '../charts/ChartsTabRow';

const COUNTRY_ROW_LIMIT = 10;

const SMLMarketsViewComponent: React.FC = () => {
  const { selectedDate, rangeDays } = useSMLDatePickerDateParam();
  const canFilterGeographically = useCanFilterGeographically();

  const topCountries = useTopCountries({
    date: selectedDate,
    rangeDays,
    limit: COUNTRY_ROW_LIMIT,
    enabled: canFilterGeographically,
  });

  return (
    <SMLContainer
      header={
        <ChartsPageHead tab={SMLRouteNames.markets}>
          <SMLDatePicker showRangePresets />
        </ChartsPageHead>
      }
    >
      <PageTabsInBody>
        <ChartsTabRow screen={SMLRouteNames.markets} />
      </PageTabsInBody>
      <Row className="mb-4 g-3">
        <Col xs={12}>
          <TopMarketsCard
            data={topCountries.data}
            isLoading={topCountries.isLoading}
            error={topCountries.error}
            retry={() => {
              topCountries.refetch().catch(console.error);
            }}
            canFilterGeographically={canFilterGeographically}
          />
        </Col>
      </Row>
      <Row className="mb-4 g-3">
        <Col xs={12}>
          <CombinedPlaylistReachPanel endDate={selectedDate} days={rangeDays} />
        </Col>
      </Row>
    </SMLContainer>
  );
};

export const SMLMarketsView = TypedMemo(SMLMarketsViewComponent);
